/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_SummaryInputs */



/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Practice_Feedback_SummaryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_summary = /** @type {((inputs?: Practice_Feedback_SummaryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_SummaryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Samenvatting")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résumé")
	return /** @type {LocalizedString} */ ("Summary")
});